
<template>
  <div class="start-instance">
    <div v-show="!formRuntimeDialog.visible" class="start-instance-content">
      <div class="header">
        <div class="search">
          <el-input
            class="el-input-search"
            v-model="keyWord"
            placeholder="请搜索要发起的审批流程"
            autofocus
            clearable
          ></el-input>
          <i class="el-icon-search" v-if="!keyWord"></i>
        </div>
        <el-select class="el-select-process" placeholder="请选择流程分类"  v-model="selectedProcess" value-key="name" clearable filterable @change="loadSelectedProcessNameData" >
            <el-option label="全部" value="all"></el-option>
            <el-option v-for="item in selectedProcessList" :label="item.name" :value="item" :key="item.id"></el-option>
          </el-select>
      </div>
      <div v-if="listShow" class="process-box start-instance-container" ref="scrollBar">
        <div v-for="(item,index) in processItems" :key="index" v-if="item.definitions.length">
          <div class="process-box-header">
            <span class="title">{{item.name}}</span>
            <span class="more" v-if="item.definitions.length>12" @click="item.displayMode=!item.displayMode">
              <span>{{item.displayMode?'收起':'展开'}}</span>
              <i class="el-icon-arrow-down" :class="{'el-icon-arrow-up':item.displayMode}"></i>
            </span>
          </div>
          <ul class="f-list">
            <li
              v-for="process in filterLessItems(item.definitions)"
              :key="process.id"
              @click="startedInstances(process)">
              <div class="process-item">
                <span> <img :src="process.appIcon || icon" :alt="process.name"></span>
                <span class="process-name" :title="process.name">{{process.name}}</span>
              </div>
            </li>
          </ul>
          <el-collapse-transition>
          <ul class="f-list" v-show="item.displayMode">
            <li
              v-for="process in filterGreaterItems(item.definitions)"
              :key="process.id"
              @click="startedInstances(process)">
              <div class="process-item">
                <span> <img :src="process.appIcon || icon" :alt="process.name"></span>
                <span class="process-name" :title="process.name">{{process.name}}</span>
              </div>
            </li>
          </ul>
        </el-collapse-transition>
      </div>
      </div>

      <div class="search-result start-instance-container" v-if="!listShow">
        <ul class="f-list" v-if="searchProcess.length">
          <li
            v-for="process in searchProcess"
            :key="process.id"
            @click="startedInstances(process)">
            <div class="process-item">
                <span> <img :src="process.appIcon || icon" :alt="process.name"></span>
                <span class="process-name" :title="process.name">{{process.name}}</span>
            </div>
          </li>
        </ul>
        <div class="none" v-else>没有找到您搜索的结果～</div>
      </div>
    </div>
     <dialog-form-runtime :formRuntimeDialog="formRuntimeDialog"></dialog-form-runtime>
  </div>
</template>

<script>
import DialogFormRuntime from '@/components/shared/dialog-form-runtime.vue'
import CookieOperation from '@/plugins/cookie'
import Img from '@/store/process/assets/icon.png'
import scrollBarMixin from '@plugins/scrollBar/index'
export default {
  name: 'processStartInstance',
  mixins: [scrollBarMixin],
  data () {
    return {
      icon: Img,
      processItems: [],
      searchProcess: [],
      keyWord: '',
      listShow: true,
      formRuntimeDialog: {
        visible: false,
        id: '',
        width: '',
        dataId: ''
      },
      selectedProcessList: [],
      selectedProcess: [],
      tenantId: ''
    }
  },
  components: {
    DialogFormRuntime
  },
  created () {
    this.loadProcessList()
    this.loadSelectedProcess()
    this.tenantId = CookieOperation.get('tenantId')
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'process-runtime') {
      this.formRuntimeDialog.title = '新建'
      this.formRuntimeDialog.type = 'process'
      this.formRuntimeDialog.id = to.query.definitionId
      this.$axios.get(`/process-api/runtime/loadProcessForm`, { params: { definitionId: to.query.definitionId } }).then((res) => {
        this.formRuntimeDialog.width = JSON.parse(res.data.component.properties).formScreen || 'full'
        this.formRuntimeDialog.visible = true
      })
    } else {
      next()
    }
  },
  methods: {
    filterLessItems (item) {
      return item.filter((el, index) => index < 12)
    },
    filterGreaterItems (item) {
      return item.filter((el, index) => index >= 12)
    },
    loadProcessList () {
      this.$axios.get('/process-api/processes/processGroup').then(res => {
        this.processItems = res.data
        this.processItems.forEach(m => {
          this.$set(m, 'displayMode', false)
        })
      })
    },
    // 获取可选择的流程分类名称
    loadSelectedProcess () {
      // 晟融单独接口
      if (this.tenantId === '16DB9E8F-4B50-003D-9ED7-32C247B72173') {
        this.$axios.get('/process-api/processes//categorys4Shengr').then(res => {
          this.selectedProcessList = res.data
        })
      } else {
        this.$axios.get('/process-api/processes/categorys').then(res => {
          this.selectedProcessList = res.data
        })
      }
    },
    // 查询已选择流程分类名称的数据
    loadSelectedProcessNameData () {
      this.searchProcess = []
      if (this.selectedProcess === 'all' || this.selectedProcess === '') {
        this.loadProcessList()
        this.listShow = true
      } else {
        this.$axios.post('/process-api/processes/processGroupByCategory', this.selectedProcess).then(res => {
          this.processItems = []
          this.processItems = res.data
          this.processItems.forEach(m => {
            this.$set(m, 'displayMode', false)
          })
          if (res.data[0].definitions.length > 0) {
            this.listShow = true
          } else {
            this.listShow = false
          }
        })
      }
    },
    search (value) {
      this.searchProcess = []
      this.listShow = !value
      this.$axios.get(`/process-api/processes/search?name=${value}`).then(res => {
        this.searchProcess = res.data
      })
    },
    startedInstances (process) {
      this.$router.push({ path: 'process-runtime', query: { definitionId: process.id } })
    }
  },
  watch: {
    keyWord (word) {
      this.search(word)
    }
  }
}
</script>

<style lang="scss">
.start-instance {
  background: #fff;
  box-shadow: 4px 4px 4px rgba(174, 222, 251, 0.1);
  border-radius: 4px;
  padding-left: 20px;
  height: 100%;
  overflow: auto;
  position: relative;

  .start-instance-content {
    height: calc(100% - 30px);
  }

  .header {
    padding-top: 16px;
    position: relative;
    .title {
      position: relative;

      &::before {
        content: "";
        position: absolute;
        left: -10px;
        top: 2px;
        width: 2px;
        height: 14px;
        background-color: #54abf1;
      }
    }
    .el-select-process{
        width: auto;
        position: absolute;
        bottom: 0;
        left: 220px;
      }
    .search {
      width: 200px;
      position: relative;
      margin: 16px 0 24px 0;

      .el-icon-search {
        position: absolute;
        top: 50%;
        right: 10px;
        margin-top: -7px;
      }
    }
  }

  .process-box {
    .process-box-header {
      margin-bottom: 20px;
      margin-top: 11px;
      .title {
        color: #666666;
        font-size: 12px;
      }
      .more {
            float: right;
            margin-right: 12px;
            cursor: pointer;
          }
    }
  }
  .f-list {
      overflow: hidden;

      li {
        width: 16%;
        margin-bottom: 10px;
        float: left;
        cursor: pointer;
        height: 50px;
        line-height: 50px;

        .process-item {
          width: 180px;
          margin: 0 auto;
          border-radius: 4px;
          overflow: hidden;

          span {
            float: left;
            &:nth-child(1) {
              width: 36px;
              height: 36px;
              margin-left: 13px;
              margin-top: 8px;
              img {
              width: 100%;
              height: 100%;
              }
          }

          &.process-name {
            color: #222222;
            margin-left: 14px;
            width: 114px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
          }
          }

          &:hover {
            background: #ECF5FB;
          }
          &:active,&:link{
            background:#D8E8F2
          }
        }
      }
    }

  .search-result {
    .none {
      width: 154px;
      height: 80px;
      background: url('./assets/05.png') no-repeat;
      background-size: 65px 67px;
      background-position: center top;
      margin: 125px auto 0;
      padding-top: 80px;
      font-weight: 600;
      color: rgba(102, 102, 102, 1);
    }
  }

  .start-instance-container {
    height: calc(100% - 60px);
    overflow: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/process/runtime/process-startInstance.vue